import React from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../contexts/AuthContext';
import { Permission } from '../types';

interface Props {
  children: React.ReactNode;
  requirePermission?: Permission;
}

export function ProtectedRoute({ children, requirePermission }: Props) {
  const { isAuthenticated, hasPermission, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (requirePermission && !hasPermission(requirePermission)) {
    return <Navigate to="/employee/entries" replace />;
  }

  return <>{children}</>;
}
